import { Component, Inject, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BackendAccessService } from '../../../Services/APICalls/backend-access-service';
import { OnboardingComponent } from '../onboarding/onboarding.component';

@Component({
    selector: 'app-update-onboarding-dialog',
    templateUrl: './update-onboarding-dialog.component.html',
    styleUrls: ['./update-onboarding-dialog.component.scss'],
    standalone: false
})
export class UpdateOnboardingDialogComponent {
  updateForm: FormGroup;
  @ViewChild(OnboardingComponent) onboardingComponent!: OnboardingComponent;

  constructor(
    public dialogRef: MatDialogRef<UpdateOnboardingDialogComponent>,
    public backend: BackendAccessService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    // Initialize the form with the data passed to the dialog
    this.updateForm = new FormGroup({
      accountSiteMappingId: new FormControl(data.accountSiteMappingId),
      accountId: new FormControl(data.accountId),
      accountNumber: new FormControl(data.accountNumber),
      accountName: new FormControl(data.accountName),
      integrationName: new FormControl(data.integrationName),
      integrationId: new FormControl(data.integrationId),
      product: new FormControl(data.product),
      anniversaryDate: new FormControl(data.anniversaryDate),
    });
  }
  /* istanbul ignore next */
  ngOnInit() {
    if (this.data) {
      this.updateForm.patchValue({
        accountSiteMappingId: this.data.accountSiteMappingId || '',
        accountName: this.data.accountName || '',
        accountNumber: this.data.accountNumber || '',
        accountId: this.data.accountId || '',
        product: this.data.product || '',
        integrationName: this.data.integrationName || '',
        integrationId: this.data.integrationId || '',
        anniversaryDate: this.data.anniversaryDate || '',
        notes: this.data.notes || '',
      });
    }
  }
  /* istanbul ignore next */
  onSubmit(): void {
    this.onboardingComponent.submitOnboardingForm();
    this.dialogRef.close(true); // You can pass 'true' to indicate a successful operation
  }
}
